<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Solicitá Dinero
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>A quien desea solicitarle dinero?</label> 
                        <KitsBusqueda url="Account/GetAccounts" placeHolder="Nombre, DNI o Mail..." v-model="model.Cuenta" :currentValue="model.Cuenta"/>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Importe</label>                         
                        <vue-numeric currency="$" v-bind:precision="2" decimal-separator	="." thousand-separator	=" " v-model="model.Importe" class="form-control"></vue-numeric>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Referencia</label> 
                        <base-input v-model="model.Referencia" placeholder="Motivo"></base-input>
                    </div>
                </div>   
                <div class="row form-group" >
                    <div class="col-md-12">
                        <save-button text="Enviar" @click="enviarDinero"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
        <contact-help-desk
        ref="contact-help-desk"
        titleModal="Solicitud Rechazada"
        />
        <modal-with-link ref="modal-with-link" />      
    </div>
</template>

<style>
</style>

<script>

    // ******************** Select ********************//
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    // ******************** Select ********************//

    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import KitsBusqueda from '@/components/KitsBusqueda';

    import JsonCSV from 'vue-json-csv';
    import ContactHelpDesk from "@/views/ContactHelpDesk";
    import ModalWithLink from "@/components/ModalWithLink.vue";
    Vue.component('downloadCsv', JsonCSV);
    
    export default{
        components: { 
            KitsBusqueda,
            "modal-with-link": ModalWithLink,
            "contact-help-desk": ContactHelpDesk 
        },
        data(){
            return{
                model : {
                    Importe: 0, Referencia: '', Cuenta: null
                },
                helpDeskInformation: {
                    Message: "",
                    Show: false,
                    ShowInfo: false,
                    WhatsappUrl: "",
                    PhoneNumber: "",
                    EmailAddress: "",
                    EmailSubject: "",
                    MessageBody: "",
                    ShowUnlockMail: false,
                    Name: "",
                    ShowContactarSoporte: false,
                }
            }
        },
        methods: {
            enviarDinero(){
                if(this.model.Cuenta == null){
                    notificationHelpers.showWarning('Alerta', 'Debe seleccionar a quien enviar dinero', this);
                    return;
                }
                if(this.model.Importe <= 0){
                    notificationHelpers.showWarning('Alerta', 'El importe debe ser superior a 0', this);
                    return;
                }

                let req = { Amount: this.model.Importe, Reference: this.model.Referencia, DestinyAccountID: this.model.Cuenta.EntityID};

                let context = this
                axiosHelpers.axiosPost('Account/MoneyRequest', req, this,
                    function(data){ 
                        if(data.ResponseVM.Success){
                            let msg = 'Hemos procesado tu solicitud de dinero a ' + context.model.Cuenta.text + ' por $' + context.model.Importe + '. Operación #'+data.ResponseVM.MoneyRequestID;
                            notificationHelpers.showSuccess('Exito', msg, context);
                            context.model.Importe = 0;
                            context.model.Referencia = '';
                        }
                    },
                    function (message) {
                    context.$refs["modal-with-link"].showModalWithParams(
                        "Solicitud Rechazada",
                        message,
                        "verificacionidentidad",
                        "Continuar"
                    );                  
                    },
                    function () {
                        context.helpDeskInformation.Show = true;
                        context.helpDeskInformation.ShowContactarSoporte = true;
                        context.helpDeskInformation.Message = 'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
                        context.helpDeskInformation.EmailAddress =
                        context.$store.getters.EmailAddress;
                        context.helpDeskInformation.EmailSubject =
                        context.$store.getters.EmailSubject;
                        context.helpDeskInformation.MessageBody =
                        context.$store.getters.MessageBody;
                        context.helpDeskInformation.UrlWhatsapp =
                        context.$store.getters.UrlWhatsapp;
                        context.helpDeskInformation.PhoneNumber =
                        context.$store.getters.PhoneNumber;
                        context.$refs["contact-help-desk"].setHelpDeskInformation(
                        context.helpDeskInformation
                        );                     
                    }
                );
            }
        }
    }
</script>